import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Icon from 'components/common/icon'
import ICONS from 'components/common/icon/const'
import BackdropModal from 'components/portal/backdrop-modal'
import useModal from 'components/portal/useModal'
import Typo from 'constants/typography'
import VoucherApiHandler from 'lib/api/voucher'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { segmentVoucherSection } from 'lib/segment'
import StateStorage from 'lib/state-storage'
import VoucherListModal from './voucher-modal/VoucherListModal'
import {
  getHotdealBadgePDP,
  sortVoucherPDP,
  filterVoucherPDP,
  sortHotdealVoucherAtTop,
} from './utils'

const VoucherPDP = ({ productId, t }) => {
  const [isOpen, setIsOpen] = useModal(false)
  const [voucherList, setVoucherList] = useState(null)
  const pmloVoucherAllUserFlagValue = true // 'EC-VoucherPDP-20220610'
  const noVoucherCacheFlagValue = true // 'NoVoucherCache-20221212'
  const token = StateStorage.getAuthToken()

  useEffect(() => {
    const getVoucherLists = () => {
      VoucherApiHandler.getVoucher(noVoucherCacheFlagValue, productId)
        .then((res) => {
          let allVouchers = res.vouchers.filter((voucher) =>
            filterVoucherPDP(voucher, productId),
          )

          allVouchers = getHotdealBadgePDP(allVouchers)

          if (!pmloVoucherAllUserFlagValue) {
            allVouchers = allVouchers.slice(0, 4)
          }

          allVouchers.sort(sortVoucherPDP)

          setVoucherList(sortHotdealVoucherAtTop(allVouchers))
        })
        .catch(() => setVoucherList(null))
    }
    if (token) {
      getVoucherLists()
    }
  }, [pmloVoucherAllUserFlagValue, noVoucherCacheFlagValue, productId, token])

  useEffect(() => {
    if (voucherList?.length) {
      segmentVoucherSection({ productId, voucherList, isVoucherViewed: true })
    }
  }, [productId, voucherList])

  if (!voucherList?.length) {
    return null
  }

  return (
    <React.Fragment>
      <div
        role="presentation"
        onClick={() => setIsOpen(true)}
        data-cy="pdp__product-manufacturer__vouchers"
        className="pdp__product-manufacturer__vouchers"
      >
        <Icon size={12} src={ICONS.voucherPurple} />
        <span className={Typo.caption}>{voucherList?.length}</span>
        <span className={Typo.caption}>
          {hasLocizeTranslation(t, 'AVAILABLE', 'available')}
        </span>
      </div>
      <BackdropModal isOpen={isOpen}>
        <VoucherListModal
          onClose={() => setIsOpen(false)}
          voucherList={voucherList}
          productId={productId}
          isCheckout={false}
        />
      </BackdropModal>
    </React.Fragment>
  )
}

VoucherPDP.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(VoucherPDP)

export default connect((state) => ({
  isPhone: state.device.isPhone,
  product: state.product.payload,
}))(Extended)
